<template>
  <div class="b-custom-table-style">
    <el-table
      ref="cTableRef"
      v-bind="$attrs"
      v-loading="isLoading"
      v-on="$listeners"
      class="b-custom-table"
      :height="1"
      element-loading-background = "rgba(255, 255, 255, .9)"
      element-loading-text = "加载中，请稍候..."
      element-loading-spinner = "el-icon-loading"
      @header-dragend="changeColWidth"
      border
    >
      <el-table-column type="selection" width="55" v-if="isCheckbox"></el-table-column>
      <slot>
        <template v-for="(column, key) in tableColumn" >
          <el-table-column :key="key" :label="column.name" :min-width="column.minWidth || 100" v-bind="column.data" :prop="column.id" v-if="column.isDefault">
            <template slot-scope="scope">
              <!-- 针对审批列表状态特定的渲染 -->
              <template v-if="column.approveId">
                <i class="approve-round" :class="`approve-round-${scope.row[column.approveId]}`"></i>
                {{scope.row[column.id] || '--'}}
              </template>
              <template v-else>
                <p class="b-c-ellipse" :class="column.isEvent && 'b-c-cursor'" :title="analysisField(column, scope.row[column.id])" @click="triggerEvent(column, scope.row, scope.$index)">
                  {{analysisField(column, scope.row[column.id])}}
                </p>
              </template>
            </template>
          </el-table-column>
        </template>
      </slot>
      <slot name="operate"></slot>
      <template slot="empty">
        <slot name="empty">
          <div class="empty-list">
            <img :src="require('@/assets/images/none-data.png')" />
            <p>暂无数据</p>
          </div>
        </slot>
      </template>
    </el-table>
    <div class="b-custome-pagination" v-if="isShowPagination">
      <div class="b-c-page-left">
        <slot name="pageLeft"></slot>
      </div>
      <el-pagination class="b-c-page" v-bind="pageData" :current-page="pageData.page" :page-size="pageData.per_page" @current-change="currentChange" layout="total,prev, pager, next,jumper" :pager-count="5"></el-pagination>
    </div>
  </div>
</template>
<script>
import {parseTime} from '@/utils/index'
export default{
  name: 'CuTable',
  props: {
    isLoading: Boolean,
    pageData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableColumn: {
      type: Array,
      default: () => {
        return []
      }
    },
    isCheckbox: Boolean,
    isShowPagination: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    triggerEvent (row, data, index) {
      if (!row.isEvent) return null;
      this.$emit(`${row.id}-handle-click`, {data, index});
    },
    currentChange (e) {
      this.$emit('currentChange', e);
    },
    analysisField (column, data) {
      if (data === 0 && column.analysis == 'number') return 0;
      if (!data) return '--';
      if (column.analysis == 'time') return parseTime(data);
      if (column.analysis == 'date') return parseTime(data, '{y}-{m}-{d}');
      if (column.analysis == 'number') return this.fmoney(data, column.numFixed || 0);
      return data;
    },
    fmoney (s, n) {
      n = n >= 0 && n <= 10 ? n : 2;
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
      let l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];
      let t = "";
      for (let i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
      }
      return t.split("").reverse().join("") + `${n === 0 ? '' : "." + r}`;
    },
    refrench () {
      return this.$refs?.cTableRef;
    },
    changeColWidth (ny, oy, col) {
      if (ny < col.minWidth) {
        col.width = col.minWidth;
      } else {
        col.width = ny;
      }
    },
    doLayout () {
      if (this.$refs.cTableRef && this.$refs.cTableRef.doLayout) {
        this.$refs.cTableRef.doLayout();
      }
    }
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/base/table.less');
</style>
